<template>
  <div class="chapter-directory-wrapper1">
    <div class="top-title no-wrap">{{directoryTitle}}</div>
    <div 
      class="chapter-directory-box"
      v-loading="listLoading"
      element-loading-text="数据正在跑步前进中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="grba(255, 255, 255, 0.5)"
      >
      <el-tree
        class="chapter-tree-1"
        id="chapterTree1"
        ref="chapterTree1"
        :data="chapterData"
        :props="defaultProps"
        :default-expand-all="true"
        node-key="chapterId"
        :expand-on-click-node="false"
        :highlight-current="true"
        :empty-text="listLoading ? '' : '暂无数据'"
        @node-click="_chapterNodeClick"
      ></el-tree>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    directoryTitle: {
      type: String,
      default: ''
    },
    currentKey: {
      
    },
    canClick: {
      type: Boolean,
      default: true
    },
    chapterData: {
      type: Array
    }
  },
  data() {
    return {
      listLoading: true,
      defaultProps: {
        children: "children",
        label: "chapterTitle"
      },
      defaultExpanedKeys: []
    };
  },
  watch: {
    chapterData: {
      immediate: true,
      handler(val) {
        if(val) {
          this.listLoading = false;
          this._setTreeCss();
        }else {
          this.listLoading = true;
        }
      }
    },
    currentKey(val, oldVal) {
      // console.log('-=-=-=-', val, oldVal);
      this.$nextTick(() => {
        this.$refs.chapterTree1.setCurrentKey(val); 
        setTimeout(() => {
          if($('.is-current .el-tree-node__content')[0]) {
            if(!this.canClick) {
              $('.is-current .el-tree-node__content').addClass('is-leaf-self');
              // $('.is-current .el-tree-node__content').css('cursor', 'default !important');
            }
            
            let _top = $('.is-current .el-tree-node__content').eq(0).offset().top;
            let _top1 = $('.chapter-directory-box').eq(0).offset().top;
            let _h1 = $('.chapter-directory-box').eq(0).height();
            if(_top - _top1 > _h1) {
              $('.chapter-directory-box')[0].scrollTo({
                top: _top - _top1 - 100,
                behavior: "smooth" 
              });
            }
            
          }
        }, 100);
      });
    }
  },
  methods: {
    _keyExpansion(val) {

    },
    /**
     * 章节选择
     * **/
    _chapterNodeClick(data, node) {
      if(data.chapterId == this.currentKey) {
        return;
      }
      if(!node.isLeaf || !this.canClick) {
        if(node.isLeaf && !this.canClick) {
          this.$emit('handleLimit');
        }
        
        this.$refs.chapterTree1.setCurrentKey(this.currentKey); 
        return;
      }
      let obj = {};
      if(node.level === 1) {
        obj.chapterOneId = node.data.chapterId;
        obj.chapterTwoId = null;
        obj.chapterThreeId = null;
      } else if(node.level === 2){
        obj.chapterOneId = node.parent.data.chapterId;
        obj.chapterTwoId = node.data.chapterId;
        obj.chapterThreeId = null;
      } else if(node.level === 3){
        obj.chapterOneId = node.parent.parent.data.chapterId;
        obj.chapterTwoId = node.parent.data.chapterId;
        obj.chapterThreeId = node.data.chapterId;
      }
      this.$emit('handleChange', obj);
    },

    /**
     * el-tree样式及title处理
     * **/
    _setTreeCss() {
      let _this = this;
      this.$nextTick(() => {
        let _ele = $('#chapterTree1 .el-tree-node__content');
        $('#chapterTree1 .el-tree-node__content').each(function() {
          let _leaf = $(this).next('.el-tree-node__children').find('.el-tree-node');
          // $(this).addClass('is-leaf-self');
          if(_leaf && _leaf.length) {
            $(this).removeClass('is-leaf-self');
          }else {
            $(this).addClass('is-leaf-self');
          }
        });
        $('#chapterTree1 .el-tree-node__label').each(function() {
          let _w = $(this).width();
          let $c = $(this).clone().css({display: 'inline', width: 'auto', visibility: 'hidden'}).appendTo('body');
          if( $c.width() > _w) {
            $(this).attr({'title': $c.text()});
          }else {
            $(this).attr({'title': ''});
          }
          $c.remove();
        });
      });
    }
  },
  created() {
    
  }
};
</script>
<style lang="less">
@color-main: #03B2B2;
.chapter-directory-wrapper1 {
  width: 270px;
  margin-right: 46px;
  background: #D3F0F0;
  display: inline-block;
  vertical-align: top;
  margin-bottom: 20px;
  height: calc(100vh - 110px);
  .top-title {
    width: 100%;
    height: 42px;
    line-height: 42px;
    padding: 0 12px;
    color: #fff;
    background: @color-main;
  }
  .chapter-directory-box {
    height: calc(100% - 42px);
    overflow-y: auto;
    .chapter-tree-1.el-tree {
      background: transparent;
      .el-tree__empty-block {
        margin-top: 200px;
      }
      .el-tree-node {
        &.is-focusable {
          .el-tree-node__content {
            background: transparent !important;
            cursor: default;
          }
        }
        .el-tree-node__content {
          height: 36px;
          line-height: 36px;
          &:hover {
            // background: #e4fbf7 !important;
          }
         
          .el-tree-node__label {
            display: inline-block;
            padding-right: 10px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          .el-tree-node__expand-icon {
            display: none;
          }
        }

        > .el-tree-node__content {
          .el-tree-node__label {
            color: #4f4f4f;
            font-weight: bold;
            padding-left: 12px;
          }
        }
        > .el-tree-node__children {
          .el-tree-node {
            .el-tree-node__content {
              padding-left: 34px;
              .el-tree-node__label {
              }
              .el-tree-node__label {
                color: #717171;
                // padding-left: 2px;
              }
            }
            .el-tree-node__children {
              .el-tree-node {
                .el-tree-node__content {
                  padding-left: 46px !important;
                  .el-tree-node__label {
                    font-weight: normal;
                    color: #666;
                  }
                }
              }
            }
          }
        }
      }

      &.el-tree--highlight-current
        .el-tree-node.is-current
        > .el-tree-node__content.is-leaf-self {
        background-color: #B6E3E3 !important;
        .el-tree-node__label {
          color: @color-main !important;
        }
      }
      
      .el-tree-node__content.is-leaf-self {
        cursor: pointer !important;
        &:hover {
          background:#beebeb !important;
        }
      }
    }
  }
}
</style>